<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kBejFo/tc-custom/9781504075251.jpg?1726454431725" alt="This image is the cover for the book Some Sort of Epic Grandeur"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Some Sort of Epic Grandeur
      </h1>
      <p class="bookDescription body article font2">
        <b>“Epic indeed, this is the definitive biography of Fitzgerald, plain and simple. There’s no reason to own another.” —<i>Library Journal</i></b><br/>  <br/><i>The Great Gatsby</i>, <i>The Beautiful and Damned</i>, <i>Tender Is the Night</i>, “The Curious Case of Benjamin Button.” These works and more elevated F. Scott Fitzgerald to his place as one of the most important American authors of the twentieth century. After struggling to become a screenwriter in Hollywood, Fitzgerald was working on <i>The Last Tycoon </i>when he died of a heart attack in 1940. He was only forty-four years old.<br/>  <br/> Fitzgerald left behind his own mythology. He was a prince charming, a drunken author, a spoiled genius, the personification of the Jazz Age, and a sacrificial victim of the Depression. Here, Matthew J. Bruccoli strips away the façade of this flawed literary hero. He focuses on Fitzgerald as a writer by tracing the development of his major works and his professional career. Beginning with his Midwest upbringing and first published works as a teenager, this biography follows Fitzgerald’s life through the successful debut of <i>This Side of Paradise</i>, his turbulent marriage to Zelda Sayre, his time in Europe among The Lost Generation, the disappointing release of <i>The Great Gatsby</i>, and his ignominious fall. As former US poet laureate James Dickey said, “the spirit of the man is in the facts, and these, as gathered and marshalled by Bruccoli over thirty years, are all we will ever need. But more important, they are what we need.”
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Matthew J. Bruccoli
      </h2>
      
      <p class="authorDescription body article">Matthew J.&#160;Bruccoli was an English professor at the University of South Carolina and the preeminent expert on F.&#160;Scott Fitzgerald, having written more than fifty books on the literary figure. Bruccoli&rsquo;s other notable subjects include Ernest Hemingway, Thomas Wolfe, and John O&rsquo;Hara. He passed away in 2008.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media/Open Road
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f95e9caa